import SvgIcon from "@mui/material/SvgIcon";

interface DryMatterIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function DryMatterIcon({
  htmlColor,
  fontSize = "medium",
}: DryMatterIconProps) {
  const strokeColor = htmlColor || "currentColor";

  return (
    <SvgIcon
      viewBox="0 0 14 14"
      fontSize={fontSize}
      htmlColor={htmlColor}
      sx={
        htmlColor
          ? {
              color: `${htmlColor} !important`,
              "& path": {
                stroke: `${htmlColor} !important`,
                fill: "none !important",
              },
            }
          : {}
      }
    >
      <path
        d="M2.34435 3.48252C1.60352 4.46252 1.16602 5.68169 1.16602 7.00002C1.16602 10.22 3.77935 12.8334 6.99935 12.8334C10.2193 12.8334 12.8327 10.22 12.8327 7.00002C12.8327 3.78002 10.2193 1.16669 6.99935 1.16669"
        stroke={strokeColor}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.91602 7.00002C2.91602 9.25752 4.74185 11.0834 6.99935 11.0834C9.25685 11.0834 11.0827 9.25752 11.0827 7.00002C11.0827 4.74252 9.25685 2.91669 6.99935 2.91669"
        stroke={strokeColor}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7 9.33335C8.28917 9.33335 9.33333 8.28919 9.33333 7.00002C9.33333 5.71085 8.28917 4.66669 7 4.66669"
        stroke={strokeColor}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
